<template>
  <div
    class="flex flex-col"
    :class="fullscreen ? 'c-box-fullscreen' : 'c-box'"
    @click.stop
  >
    <div :class="fullscreen ? 'header-box-fullscreen' : 'header-box'">
      <p
        style="width: 90%; margin: 0 auto"
        :title="preViewData.name"
        class="nowrap"
      >
        {{ preViewData.name }}
      </p>
      <!-- 导出图标 -->
      <div class="export-pdf">
        <div class="iconfont icon-style" @click="exportPdf">&#xe632;</div>
      </div>
      <div class="fullScreen" @click="goNewPage()">
        <div class="iconfont icon-style" v-if="fullscreen">&#xe749;</div>
        <div class="iconfont icon-style" v-else>&#xe60f;</div>
      </div>
      <div class="close-box" @click="closePreview">×</div>
    </div>
    <div id="centent-box" class="centent-box flex-1 flex">
      <div class="left-素材 flex-1">
        <!-- 空状态 -->
        <div style="height: 100%; position: relative" v-if="emptyPrompt">
          <div
            class="flex flex-col align-items-center"
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <div>
              <img
                style="width: 50%; height: 50%; margin: 0 auto; display: block"
                src="~@/assets/images/img55.png"
                alt=""
              />
            </div>
            <div style="margin-top: 20px; font-size: 18px">
              点击右侧文件查看
            </div>
          </div>
        </div>
        <!-- pdf 格式 -->
        <div
          :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'"
          v-if="
            previewType === 'pdf' ||
            previewType === 'doc' ||
            (previewType === 'docx' &&
              defaultGraph === false &&
              reviewShow === false)
          "
        >
          <iframe
            width="100%"
            :src="previewUrl"
            name="123"
            scrolling-y="auto"
            frameborder="0"
            style="width: 100%; height: 100%; background: #fff"
          ></iframe>
        </div>
        <!-- jpg png bmp 图片格式 -->
        <div
          :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'"
          v-if="
            previewType === 'jpg' ||
            previewType === 'png' ||
            previewType === 'jpeg' ||
            (previewType === 'bmp' &&
              defaultGraph === false &&
              reviewShow === false)
          "
        >
          <img class="img-preview" :src="previewUrl" alt="" />
        </div>
        <!-- mp4 视频格式 -->
        <div
          :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'"
          v-if="previewType === 'mp4' || previewType === 'MP4'"
        >
          <video
            style="height: 100%; width: 100%"
            controls="controls"
            autoplay="autoplay"
            :src="previewUrl"
          ></video>
        </div>
        <!-- 其他视频格式 -->
        <div
          style="height: 100%; position: relative"
          v-if="
            previewType !== '' &&
            previewType !== 'pdf' &&
            previewType !== 'jpg' &&
            previewType !== 'png' &&
            previewType !== 'bmp' &&
            previewType !== 'mp4' &&
            previewType !== 'jpeg' &&
            defaultGraph === false &&
            reviewShow === false
          "
        >
          <!--          <a-button type="success" @click="downLoadFile">下载文件预览</a-button>-->
          <div class="flex flex-center flex-col align-items-center">
            <div
              class="flex flex-col align-items-center"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              "
            >
              <div>
                <img
                  style="
                    width: 50%;
                    height: 50%;
                    margin: 0 auto;
                    display: block;
                  "
                  src="~@/assets/images/img55.png"
                  alt=""
                />
              </div>
              <div style="margin-top: 20px; font-size: 18px">
                <a-button
                  type="button"
                  style="width: 180px; height: 40px; font-size: 16px"
                  @click="downLoadFile"
                >
                  <a :href="this.previewUrl" download>点击下载</a>
                </a-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 评审表格 -->
        <div id="review-content" class="review-content" v-if="reviewShow">
          <a-table
            class="table"
            :columns="columns"
            :data-source="reviewData.dataList"
            bordered
            :pagination="false"
            :rowKey="(record) => record.id"
          >
            <!-- 
            :scroll="{ x: false, y: 240 }"

           -->
            <span slot="oneTarget" slot-scope="text">{{ text }}</span>
            <template slot="itemScore" slot-scope="text, record">
              <editable-cell
                :evaluationTablePreview="evaluationTablePreview"
                :max="record.score"
                :text="text"
                @change="onCellChange(record.id, 'itemScore', $event)"
              />
            </template>
          </a-table>
          <div class="target-score">
            <span>
              指标总分值：
              <span class="number">{{ targetTotalScore }}</span>
              <span class="score">分</span>
            </span>
            <span style="margin-left: 30px">
              总得分：
              <span class="number">{{ totalPoints }}</span>
              <span class="score">分</span>
            </span>
          </div>
          <div class="expertReviews">
            <div class="expertReviews-title">专家评语</div>
            <a-textarea
              class="remark-input"
              v-model="reviewData.remark"
              placeholder="请输入评语~"
              :maxLength="500"
              :auto-size="{ minRows: 4, maxRows: 6 }"
              :disabled="evaluationTablePreview"
              @change="remarkChange"
            />
          </div>
          <div class="submit" @click="submit" v-if="!evaluationTablePreview">提交</div>
        </div>
        <div v-if="defaultGraph" style="margin: 20% 0">
          <div class="flex flex-center flex-col align-items-center">
            <div>
              <img
                style="width: 465px; height: 291px"
                src="~@/assets/images/img53.png"
                alt=""
              />
            </div>
            <div style="fontsize: 20px">暂无内容</div>
          </div>
        </div>
      </div>
      <div class="right-filelist-box flex flex-col">
        <!--  :style="[
            { height: type === 'expert' ? 'auto' : '100%' },
            { 'max-height': type === 'expert' ? '70%' : '' },
          ]" -->
        <div class="title-hint" v-if="previewTimeout">
          <img src="@/assets/images/hint.png" alt="" />
          <span>预览作品时，可继续评审</span>
        </div>
        <div class="top-filelist flex-1">
          <a-tree
            showLine
            v-if="fileTreeList && fileTreeList.length"
            @select="onSelect"
            :defaultExpandAll="true"
            :autoExpandParent="true"
            :defaultExpandParent="true"
          >
            <a-icon style="color: #2155B5" slot="switcherIcon" type="down" />
            <a-tree-node
              style="color: #2155B5"
              v-for="item in fileTreeList"
              :key="item.key"
              :title="item.title"
            >
              <a-tree-node
                style="color: #2155B5"
                v-for="item1 in item.children"
                :key="item1.proviewPath ? item1.proviewPath : item1.filePath"
                :title="getFileName(item1.filePath)"
              >
              </a-tree-node>
            </a-tree-node>
          </a-tree>
        </div>
        <div class="bottom-evaluate" v-if="type === 'expert'">
          <!-- <div class="flex" style="margin-bottom: 8px">
            <div>评审模板下载 :</div>
            <div class="flex align-items-center"> -->
          <!--              &nbsp;-->
          <!--              <img-->
          <!--                class="img-box-min"-->
          <!--                src="../../assets/images/img25.png"-->
          <!--                alt=""-->
          <!--              /><a-->
          <!--                :href="`${path}2.jpg`"-->
          <!--                download="项目评审表模板.jpg"-->
          <!--                style="color: #2155B5"-->
          <!--                >项目评审表.png</a-->
          <!--              >-->
          <!-- </div>
          </div> -->
          <!-- <div>
            <a class="file flex flex-center align-items-center">
              <input
                type="file"
                id="people-export"
                :disabled="!previewTimeout || loading"
                accept=".jpeg,.jpg,.png,.bmp"
                value="shancgahunwenjai "
                @change="onFileChange"
                @click="onFile"
                style="cursor: pointer"
              />
              <img
                v-if="fileName === null"
                class="img-box"
                src="../../assets/images/img26.png"
                alt=""
              />
              <img
                v-if="fileName !== null"
                class="img-box"
                src="../../assets/images/img26.png"
                alt=""
              />
              <span>{{
                !previewTimeout && fileName === null
                  ? "未上传文件"
                  : "上传评价表"
              }}</span>
            </a>
          </div> -->
          <div
            class="file-list"
            v-if="fileName !== null"
            @click="previewFile(fileName1)"
          >
            <a-tooltip>
              <template slot="title"> {{ fileName }} </template>
              <img
                class="img-box-min"
                src="../../assets/images/img25.png"
                alt=""
              />
              {{ fileName }}
            </a-tooltip>
          </div>
          <!-- <div class="num-box flex align-items-center">
            <div class="flex-1" style="text-align: center">当前分数 :</div>
            <input
              class=""
              :disabled="!previewTimeout"
              style="text-align: center; color: #2155B5"
              v-model="evaluationData.score"
              type="text"
            />
          </div>
          <div class="submit-btn" @click="submitPreview" v-if="previewTimeout">
            提交
          </div> -->
          <div class="review" @click="review" v-if="previewTimeout">
            <img src="@/assets/images/review.png" alt="" />
            {{ reviewBtn }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input-number :max="max" :min="0" :value="value" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          <span style="width:100%;">{{ value || ' ' }}</span>
          <a-icon v-if="!evaluationTablePreview" type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: 0
    },
    evaluationTablePreview: {
      type: Blob,
      default: false
    }
  },
  data() {
    return {
      value: this.text,
      editable: false,
    };
  },
  methods: {
    handleChange(value) {
      this.value = value;
    },
    check() {
      this.editable = false;
      this.$emit("change", this.value);
    },
    edit() {
      this.editable = true;
    },
  },
};
import { baseURL } from "@/utils/request.js";
import { fileUpdate, getAction, postAction } from "@/api/index";
export default {
  name: "",
  components: {
    EditableCell,
  },
  props: {
    preViewData: {
      type: Object,
    },
    type: String,
    previewTimeout: Boolean,
    evaluationTablePreview: {
      type: Blob,
      default: false
    }
  },
  data() {
    return {
      previewUrl: "/1.pdf",
      path: baseURL,
      previewType: "",
      title: "",
      fileList: null,
      fileTreeList: null,
      defaultGraph: false,
      fileName: null,
      fileName1: null,
      loading: false,
      fullscreen: false,
      evaluationData: {
        score: "",
        scoreFile: "",
        applyIds: [],
      },
      columns: [
        {
          title: "建设指标",
          dataIndex: "oneTarget",
          key: "oneTarget",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "oneTarget" },
          customRender: (text, record, index) => {
            const obj = {
              children: record.oneTarget,
              attrs: {},
            }
            obj.attrs.rowSpan = this.columnsInit(record.oneTarget, this.reviewData.dataList, 'oneTarget', index)
            return obj
          },
        },
        {
          title: "二级指标",
          dataIndex: "twoTarget",
          key: "twoTarget",
          align: "center",
        },
        {
          title: "指标内涵",
          dataIndex: "content",
          key: "content",
          ellipsis: true,
          align: "center",
        },
        {
          title: "分值",
          dataIndex: "score",
          key: "score",
          width: 80,
          align: "center",
        },
        {
          title: "得分",
          dataIndex: "itemScore",
          key: "itemScore",
          align: "center",
          width: 130,
          scopedSlots: { customRender: "itemScore" },
        },
      ],
      reviewData: {
        // 专家评语
        remark: "",
        // 指标数据
        dataList: [],
      },
      // 评审
      reviewShow: false,
      emptyPrompt: false,
      applyType: 0,
      // 指标总分值
      targetTotalScore: 0,
      // 总得分
      totalPoints: 0,
      reviewBtn: "开始评审",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.evaluationData.applyIds.push(this.preViewData.id);
    if (
      this.preViewData &&
      this.preViewData.score !== null &&
      this.preViewData.score !== "-"
    ) {
      this.evaluationData.score = this.preViewData.score;
    }
    if (
      this.preViewData &&
      this.preViewData.scoreFile !== null &&
      this.preViewData.scoreFile !== "-"
    ) {
      let newName = this.preViewData.scoreFile.slice(
        this.preViewData.scoreFile.lastIndexOf("/") + 1
      );
      let firstname = newName.slice(0, newName.lastIndexOf("_"));
      let lastname = newName.slice(newName.lastIndexOf("."));
      this.fileName = firstname + lastname;
      this.fileName1 = newName;
      this.evaluationData.scoreFile = this.preViewData.scoreFile.slice(8);
    }
    if (
      this.preViewData &&
      this.preViewData.applyFiles &&
      this.preViewData.applyFiles.length > 0
    ) {
      let treeFile = [];
      let treeFile1 = {
        title: "本校“三个一工程”工作方案",
        key: 1,
        children: [],
      };
      let treeFile2 = {
        title: "校级立项相关文件",
        key: 2,
        children: [],
      };
      let treeFile3 = {
        title: "专项资金经费支持相关文件",
        key: 3,
        children: [],
      };
      let treeFile4 = {
        title: "申报书",
        key: 4,
        children: [],
      };
      let treeFile5 = {
        title: "微课视频",
        key: 5,
        children: [],
      };
      let treeFile6 = {
        title: "佐证材料",
        key: 6,
        children: [],
      };
      let treeFile7 = {
        title: "工作室照片",
        key: 7,
        children: [],
      };
      let treeFile8 = {
        title: "思政教育工作室宣传片",
        key: 8,
        children: [],
      };
      let treeFile9 = {
        title: "特色文化育人品牌成果展示宣传片",
        key: 9,
        children: [],
      };
      let treeFile10 = {
        title: "建设方案",
        key: 10,
        children: [],
      };
      let treeFile11 = {
        title: "实施报告",
        key: 11,
        children: [],
      };

      treeFile.push(treeFile1);
      treeFile.push(treeFile2);
      treeFile.push(treeFile3);
      treeFile.push(treeFile4);
      treeFile.push(treeFile5);
      treeFile.push(treeFile6);
      treeFile.push(treeFile7);
      treeFile.push(treeFile8);
      treeFile.push(treeFile9);
      treeFile.push(treeFile10);
      treeFile.push(treeFile11);

      if (this.$route.name === "szStudio") {
        this.fileList = treeFile.filter((item1) => {
          if (
            item1.key === 1 ||
            item1.key === 2 ||
            item1.key === 3 ||
            item1.key === 4 ||
            item1.key === 6 ||
            item1.key === 7 ||
            item1.key === 8 ||
            item1.key === 10 ||
            item1.key === 11
          ) {
            return item1;
          }
        });
      } else if (this.$route.name === "educationalBrand") {
        this.fileList = treeFile.filter((item1) => {
          if (
            item1.key === 1 ||
            item1.key === 2 ||
            item1.key === 3 ||
            item1.key === 4 ||
            item1.key === 6 ||
            item1.key === 9 ||
            item1.key === 10 ||
            item1.key === 11
          ) {
            return item1;
          }
        });
      } else {
        this.fileList = treeFile.filter((item1) => {
          if (
            item1.key === 1 ||
            item1.key === 2 ||
            item1.key === 3 ||
            item1.key === 4 ||
            item1.key === 6 ||
            item1.key === 5
          ) {
            return item1;
          }
        });
      }

      let newFileList = this.fileList;
      for (var i = 0; i < newFileList.length; i++) {
        for (var j = 0; j < this.preViewData.applyFiles.length; j++) {
          if (newFileList[i].key == this.preViewData.applyFiles[j].fileType) {
            newFileList[i].children.push(this.preViewData.applyFiles[j]);
          }
        }
      }
      this.fileTreeList = newFileList;
    } else {
      this.defaultGraph = true;
      let treeFile = [];
      let treeFile1 = {
        title: "本校“三个一工程”工作方案",
        children: [],
      };
      let treeFile2 = {
        title: "校级立项相关文件",
        children: [],
      };
      let treeFile3 = {
        title: "专项资金经费支持相关文件",
        children: [],
      };
      let treeFile4 = {
        title: "申报书",
        children: [],
      };
      let treeFile5 = {
        title: "微课视频",
        children: [],
      };
      let treeFile6 = {
        title: "佐证材料",
        children: [],
      };
      let treeFile7 = {
        title: "工作室照片",
        children: [],
      };
      let treeFile8 = {
        title: "思政教育工作室宣传片",
        children: [],
      };
      let treeFile9 = {
        title: "特色文化育人品牌成果展示宣传片",
        children: [],
      };
      let treeFile10 = {
        title: "建设方案",
        key: 10,
        children: [],
      };
      let treeFile11 = {
        title: "实施报告",
        key: 11,
        children: [],
      };
      treeFile.push(treeFile1);
      treeFile.push(treeFile2);
      treeFile.push(treeFile3);
      treeFile.push(treeFile4);
      treeFile.push(treeFile5);
      treeFile.push(treeFile6);
      treeFile.push(treeFile7);
      treeFile.push(treeFile8);
      treeFile.push(treeFile9);
      treeFile.push(treeFile10);
      treeFile.push(treeFile11);
      this.fileTreeList = treeFile;
    }
    if (this.$route.name === "szStudio") {
      this.applyType = 1;
    } else if (this.$route.name === "educationalBrand") {
      this.applyType = 2;
    } else {
      this.applyType = 3;
    }
    this.emptyPrompt = true;
    if (window.sessionStorage.getItem(`${this.preViewData.id}reviewData`)) {
      this.reviewBtn = "继续评审";
    } else {
      this.reviewBtn = "开始评审";
    }

  },
  methods: {
    getFileName(name) {
      let newName = name.slice(name.lastIndexOf("/") + 1);
      let firstname = newName.slice(0, newName.lastIndexOf("_"));
      let lastname = newName.slice(newName.lastIndexOf("."));
      return firstname + lastname;
    },
    onSelect(selectedKeys, { node }) {
      if (typeof selectedKeys[0] === "string") {
        let fileName = selectedKeys[0].lastIndexOf(".");
        this.previewType = selectedKeys[0].substring(
          fileName + 1,
          selectedKeys[0].length
        );
        if (this.previewType === "doc" || this.previewType === "docx") {
          this.previewUrl = selectedKeys[0];
        } else {
          this.previewUrl = baseURL + selectedKeys[0];
        }
      } else {
        node.onExpand();
      }
      if(this.reviewShow){
        this.reviewBtn = '继续评审'
        // 评审表格
        this.reviewShow = false;
      }
      // 默认提示
      this.emptyPrompt = false;
    },
    goNewPage() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
      this.$emit("goNewPage", this.fullscreen);
    },
    onFileChange(e) {
      if (!this.loading) {
        this.loading = true;
        if (e && e.target && e.target.files) {
          let fileSize = e.target.files[0].size > 1024 * 1024 * 500;
          let fileType = e.target.files[0].type;
          if (
            fileType == "image/jpeg" ||
            fileType == "image/png" ||
            fileType == "image/jpg" ||
            fileType == "image/bmp"
          ) {
            if (!fileSize) {
              this.fileName = "文件上传中...";
              const formData = new FormData();
              formData.append("file", e.target.files[0]);
              formData.append("biz", "linxuan");
              fileUpdate(formData).then((res) => {
                if (res.code === 0) {
                  this.$message.success("上传成功");
                  this.evaluationData.scoreFile = res.message;
                  this.previewUrl = baseURL + res.message;
                  this.previewType = "png";
                  let newName = res.message.slice(
                    res.message.lastIndexOf("/") + 1
                  );
                  let firstname = newName.slice(0, newName.lastIndexOf("_"));
                  let lastname = newName.slice(newName.lastIndexOf("."));
                  this.fileName = firstname + lastname;
                  this.fileName1 = newName;
                  this.loading = false;
                  if (this.fullscreen) {
                    this.goNewPage();
                  } else {
                    // console;
                  }
                } else {
                  this.$message.error("上传失败");
                }
              });
            } else {
              this.$message.error("请上传小于 500M 的文件");
            }
          } else {
            this.$message.error("请上传图片格式的文件");
            this.loading = false;
          }
        } else {
          return;
        }
      } else {
        this.$message.error("图片上传中");
      }
    },
    previewFile(name) {
      this.previewUrl = baseURL + "linxuan/" + name;
      let lastname = name.lastIndexOf(".");
      this.previewType = name.substring(lastname + 1, name.length);
    },
    closePreview() {
      this.$emit("closePreview");
      if (this.fullscreen) {
        this.goNewPage();
      }
    },
    downLoadFile() {
      // window.open(this.previewUrl);
    },
    onFile() {
      if (this.fullscreen) {
        this.goNewPage();
      } else {
        console;
      }
    },
    submitPreview() {
      if (this.evaluationData.scoreFile === "") {
        this.$message.error("请上传评审文件");
        return false;
      }
      if (this.evaluationData.score === "") {
        this.$message.error("请输入评审分数");
        return false;
      }
      if (this.loading) {
        this.$message.error("评审文件上传中");
        return false;
      }
      if (this.fullscreen) {
        this.goNewPage();
      }
      this.$emit("submitPreview", this.evaluationData);
    },
    // 开始评审 继续评审
    review(type,index) {
      this.reviewShow = true;
      this.emptyPrompt = false;
      this.defaultGraph = false;
      this.previewType = "";
      if (window.sessionStorage.getItem(`${this.preViewData.id}reviewData`)) {
        this.reviewData = JSON.parse(window.sessionStorage.getItem(`${this.preViewData.id}reviewData`));
        this.targetTotalScore = 0
        this.totalPoints = 0
        this.reviewData.dataList.forEach((item) => {
          this.targetTotalScore += item.score;
          this.totalPoints += Number(item.itemScore);
        });
        if (!this.reviewData.hasTwo) {
          this.columns = this.columns.filter(
            (item) => item.title != "二级指标"
          );
        }
      } else {
        this.getReviewTable(type,index);
      }
    },
    // 获取评审表格
    getReviewTable(type,index) {
      let params = {
        applyType: this.applyType,
        applyId: this.preViewData.id,
        expertUserId: this.$store.state.user.id,
      };
      if(type && type == 'reviewTable'){
        params.expertUserId = this.preViewData.expertApplys[index].expertUserId
      }
      getAction("/lx/lxExpertItem/tablelist", params).then((res) => {
        if (res.code == 200) {
          this.reviewData = res.result;
          this.targetTotalScore = 0
          this.totalPoints = 0
          this.reviewData.dataList.forEach((item) => {
            this.targetTotalScore += item.score;
            this.totalPoints += Number(item.itemScore);
          });
          if (!this.reviewData.hasTwo) {
            this.columns = this.columns.filter(
              (item) => item.title != "二级指标"
            );
          }
        }
      });
    },
    onCellChange(key, dataIndex, value) {
      const dataSource = [...this.reviewData.dataList];
      const target = dataSource.find((item) => item.id === key);
      if (target) {
        target[dataIndex] = value;
        this.reviewData.dataList = dataSource;
      }
      this.totalPoints = 0;
      this.reviewData.dataList.forEach((item) => {
        this.totalPoints += Number(item.itemScore);
      });
      window.sessionStorage.setItem(
        `${this.preViewData.id}reviewData`,
        JSON.stringify(this.reviewData)
      );
    },
    // 评审提交
    submit() {
      let map = {};
      this.reviewData.dataList.forEach((item) => {
        map[item.id] = Number(item.itemScore);
      });
      let params = {
        itemScores: map,
        applyId: this.preViewData.id,
        remark: this.reviewData.remark,
      };
      postAction("/lx/lxExpertItem/settingScore", params).then((res) => {
        if (res.code == 200) {
          this.$message.success("提交成功");
          this.$emit("submit");
          window.sessionStorage.removeItem(`${this.preViewData.id}reviewData`);
        }
      });
    },
    // 合并单元格
    columnsInit(text, data, key, index) {
      if (index !== 0 && text == data[index - 1][key]) {
        return 0
      }
      let rowSpan = 1 //判断下一行是否相等
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) {
          break
        }
        rowSpan++
      }
      return rowSpan
    },
    // 专家评语输入
    remarkChange(){
      window.sessionStorage.setItem(
        `${this.preViewData.id}reviewData`,
        JSON.stringify(this.reviewData)
      );
    },
    // 导出pdf
    exportPdf(){
      document.title = this.preViewData.name
      // 即时延时
      setTimeout(() => {
        if(document.getElementById('review-content')){
          const printData = document.getElementById('review-content').innerHTML
          window.document.body.innerHTML = printData
          window.print()
          window.location.reload()
        }
        
      })
    }
  },
};
</script>

<style scoped lang="scss">
.img-box {
  width: 15px;
  height: 17px;
  margin-right: 8px;
}
.img-box-min {
  width: 10px;
  height: 12px;
  margin-right: 8px;
}

.c-box {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/img49.png") no-repeat;
  background-size: 100% 100%;
}
.c-box-fullscreen {
  width: 100%;
  height: 100%;
  background: #fff;
  /* background: url("../../assets/images/img49.png") no-repeat;
  background-size: 100% 100%;*/
}
.header-box-fullscreen {
  height: 80px;
  line-height: 78px;
  position: relative;
  text-align: center;
  background: #2155B5;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
}
.header-box {
  height: 80px;
  line-height: 78px;
  position: relative;
  text-align: center;
  background: #2155B5;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  margin: 0px 19px 0px 9px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
}
.centent-box {
  margin: 0 12px 5px 0;
  padding: 10px 25px;
  height: 80%;
  .left-preview-box {
    position: relative;
    height: 100%;
    .review-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding-bottom: 10px;
    }
    .target-score {
      margin-top: 10px;
      color: #6c6c6c;
      text-align: right;
      .number {
        font-size: 20px;
        color: #c83933;
      }
      .score {
        color: #c83933;
      }
    }
    .expertReviews-title {
      font-size: 18px;
    }
    .expertReviews-title:before {
      display: inline-block;
      width: 6px;
      height: 22px;
      background: #c83933;
      border-radius: 5px;
      content: "";
      /**
    这个指为正的话 小方块就往上， 为负的话，小方块就往下
    */
      vertical-align: middle;
      margin-right: 6px;
    }
    .remark-input {
      margin-top: 20px;
      resize: none;
    }
    .submit {
      width: 263px;
      height: 41px;
      background: #c83933;
      border: 1px solid #2155B5;
      border-radius: 8px;
      line-height: 41px;
      text-align: center;
      margin: 0 auto;
      color: #ffffff;
      margin-top: 30px;
      cursor: pointer;
    }
  }
  .right-filelist-box {
    width: 267px;
    height: 100%;
    padding-bottom: 10px;
    margin-left: 20px;
    .title-hint {
      width: 267px;
      height: 41px;
      background: #ffefdc;
      line-height: 41px;
      color: #ff7800;
      text-align: center;
      img {
        vertical-align: middle;
      }
      span {
        font-weight: bold;
        vertical-align: middle;
        margin-left: 10px;
      }
    }
    .top-filelist {
      background: #fff6f4;
      padding: 15px 10px;
      overflow-y: auto;
      margin-top: 10px;
    }
    .top-filelist::-webkit-scrollbar {
      display: none;
    }
    .bottom-evaluate {
      margin-top: 12px;
      .num-box {
        height: 35px;
        margin-bottom: 18px;
        border-radius: 10px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2155B5;
        background: #ffe4de;
        input {
          border: none;
          padding: 0 15px;
          width: 155px;
          height: 22px;
          margin-right: 8px;
          border-radius: 6px;
          color: #383838;
        }
      }
    }
    .submit-btn {
      height: 35px;
      line-height: 35px;
      text-align: center;
      cursor: pointer;
      background: #2155B5;
      border-radius: 10px;
      margin-bottom: 10px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
    .review {
      width: 267px;
      height: 60px;
      background: rgba(255, 209, 207, 0.4);
      border: 1px solid #2155B5;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #c83933;
      text-align: center;
      line-height: 60px;
      cursor: pointer;
    }
  }
}
.file {
  position: relative;
  width: 100%;
  height: 35px;
  background: #fff;
  border: 1px solid #2155B5;
  border-radius: 10px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 35px;
  margin-bottom: 8px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
.img-preview-box {
  position: relative;
  // max-height: 718px;
  overflow: hidden;
  height: 100%;
  background: #000;
}
.img-preview-box-fullscreen {
  position: relative;
  overflow: hidden;
  height: 100%;
  background: #000;
}
.img-preview {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.close-box {
  position: absolute;
  color: #fff;
  font-size: 40px;
  right: 3%;
  cursor: pointer;
  top: -2px;
}
.submit-btn-disabled {
  opacity: 0.6;
  cursor: no-drop !important;
}
.file-list {
  margin: 10px 0;
  padding: 0 15px;
  overflow: hidden;
  cursor: pointer;
  white-space: nowrap;
}
.file-list:hover {
  color: #2155B5;
}

.bg-img-box {
  background: url("~@/assets/images/img53.png") no-repeat;
  background-size: 100% 100%;
}
.export-pdf{
  position: absolute;
  right: 12%;
  top: 2px;
  z-index: 99;
  cursor: pointer;
  font-size: 26px;
}
.fullScreen {
  color: #fff;
  position: absolute;
  right: 7%;
  top: 2px;
  z-index: 99;
  cursor: pointer;
}
.icon-style {
  font-size: 25px;
}

/deep/ .table {
  // height: 300px;
  overflow: auto;
}
/deep/ .table::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
/deep/ .table::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #e8e9e9;
  border-radius: 3px;
}
/deep/ .table::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ffffff;
}
/deep/ .editable-cell {
  position: relative;
}

/deep/ .editable-cell-text-wrapper {
  padding-right: 24px;
}
/deep/ .editable-cell-input-wrapper{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .editable-cell-icon-check{
    line-height: none !important;
    margin-left: 15px;
  }
}
/deep/ .editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

/deep/ .editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

/deep/ .editable-cell-icon {
  // line-height: 18px;
  display: none;
}

/deep/ .editable-cell-icon-check {
  line-height: 28px;
}

/deep/ .editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

/deep/ .editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

/deep/ .editable-add-btn {
  margin-bottom: 8px;
}
/deep/ .editable-cell-text-wrapper{
  width: 40%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 14px 0;
  border-bottom: 2px solid #2155B5;
  box-sizing: border-box;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
